import { $authHost } from ".."

export const editSupplyOrderItemAPI = async (dataForBd) => {
    const {data} = await $authHost.post(`api/supply_order_items/${dataForBd.id}`, dataForBd)
    return data
}

export const editSupplyOrderItemReceivedAPI = async (dataForBd) => {
    const {data} = await $authHost.post(`api/supply_order_items/change_received/${dataForBd.id}`, dataForBd)
    return data
}